<section class="go-container">
  <app-form-control-docs class="go-column go-column--100"></app-form-control-docs>

  <go-card id="form-select-control" class="go-column go-column--100">
    <ng-container go-card-header>
      <h2 class="go-heading-2 go-heading--no-wrap">Component Control</h2>
      <go-copy cardId="form-select-control" goCopyCardLink></go-copy>
    </ng-container>
    <div class="go-container" go-card-content>

      <div class="go-column go-column--100">
        <p class="go-body-copy go-body-copy--no-margin">
          As with most of the form components, the only <code class="code-block--inline">@Input</code>
          required of the text area component is a <code class="code-block--inline">FormControl</code>.
          The FormControl can be passed in via the <code class="code-block--inline">[control]</code>
          attribute on the &lt;go-text-area&gt; component.
        </p>
      </div>

      <div class="go-column go-column--100 go-column--no-padding">
        <div class="go-container">
          <div class="go-column go-column--50">
            <h4 class="go-heading-4 go-heading--underlined">View</h4>
            <go-select [control]="select1"></go-select>
          </div>
          <div class="go-column go-column--50">
            <h4 class="go-heading-4 go-heading--underlined">Code</h4>
            <code
              [highlight]="select1Code"
              class="code-block--no-bottom-margin">
            </code>
          </div>
        </div>
      </div>

    </div>
  </go-card>

  <go-card id="form-select-label" class="go-column go-column--100">
    <ng-container go-card-header>
      <h2 class="go-heading-2 go-heading--no-wrap">Component Label</h2>
      <go-copy cardId="form-select-label" goCopyCardLink></go-copy>
    </ng-container>
    <div class="go-container" go-card-content>

      <div class="go-column go-column--100">
        <p class="go-body-copy go-body-copy--no-margin">
          All form components include an <code class="code-block--inline">@Input() label: string;</code>
          that can be used to add a label to the select components.
          In addition to displaying an HTML label, the text passed
          in via the <code class="code-block--inline">[label]</code>
          attribute is used to generate a unique ID to associate the
          label with the select. If no label is passed in, a generic,
          but still unique ID will be generated.
        </p>
      </div>

      <div class="go-column go-column--100 go-column--no-padding">
        <div class="go-container">
          <div class="go-column go-column--50">
            <h4 class="go-heading-4 go-heading--underlined">View</h4>
            <go-select
              [control]="select2"
              label="Candy">
            </go-select>
          </div>
          <div class="go-column go-column--50">
            <h4 class="go-heading-4 go-heading--underlined">Code</h4>
            <code
              [highlight]="select2Code"
              class="code-block--no-bottom-margin">
            </code>
          </div>
        </div>
      </div>

    </div>
  </go-card>

  <go-card id="form-select-key" class="go-column go-column--100">
    <ng-container go-card-header>
      <h2 class="go-heading-2 go-heading--no-wrap">Component Key</h2>
      <go-copy cardId="form-select-key" goCopyCardLink></go-copy>
    </ng-container>
    <div class="go-container" go-card-content>

      <div class="go-column go-column--100">
        <p class="go-body-copy go-body-copy--no-margin">
          As stated above the label attribute is used to generate a
          unique ID to associate the label with the select. As this might
          not be desired, the <code class="code-block--inline">@Input() key: string;</code>
          can be used to configure the ID attribute of the select directly.
          Anything passed into the component via the <code class="code-block--inline">[key]</code>
          attribute will be used to both assign the ID to the select and
          associate the label with the select.
        </p>
      </div>

      <div class="go-column go-column--100 go-column--no-padding">
        <div class="go-container">
          <div class="go-column go-column--50">
            <h4 class="go-heading-4 go-heading--underlined">View</h4>
            <go-select
              [control]="select3"
              label="Favorite Candy"
              key="your-favorite-candy">
            </go-select>
          </div>
          <div class="go-column go-column--50">
            <h4 class="go-heading-4 go-heading--underlined">Code</h4>
            <code
              [highlight]="select3Code"
              class="code-block--no-bottom-margin">
            </code>
          </div>
          <div class="go-column go-column--100">
            <h4 class="go-heading-4 go-heading--underlined">Example Output</h4>
            <p class="go-body-copy">
              Notice in the below example output that the <code class="code-block--inline">key</code> has been assigned
              to both the <code class="code-block--inline">id</code> attribute on
              the select and the <code class="code-block--inline">for</code> attribute
              on the label.
            </p>
            <code
              [highlight]="select3KeyCode"
              class="code-block--no-bottom-margin">
            </code>
          </div>
        </div>
      </div>

    </div>
  </go-card>

  <go-card id="form-select-hints" class="go-column go-column--100">
    <ng-container go-card-header>
      <h2 class="go-heading-2 go-heading--no-wrap">Component Hints</h2>
      <go-copy cardId="form-select-hints" goCopyCardLink></go-copy>
    </ng-container>
    <div class="go-container" go-card-content>

      <div class="go-column go-column--100">
        <p class="go-body-copy go-body-copy--no-margin">
          Form hints exist to help give more information about the
          selects they are attached to. The <code class="code-block--inline">@Input() key: Array&lt;string&gt;</code>
          can be used to pass in an array of hints to the select component.
        </p>
      </div>

      <div class="go-column go-column--100 go-column--no-padding">
        <div class="go-container">
          <div class="go-column go-column--50">
            <h4 class="go-heading-4 go-heading--underlined">View</h4>
            <go-select
              [control]="select4"
              label="Favorite Candy"
              [hints]="hints">
            </go-select>
          </div>
          <div class="go-column go-column--50">
            <h4 class="go-heading-4 go-heading--underlined">Code</h4>
            <code
              [highlight]="select4HintsCode"
              class="code-block--no-bottom-margin">
            </code>
            <code
              [highlight]="select4Code"
              class="code-block--no-bottom-margin">
            </code>
          </div>
        </div>
      </div>

    </div>
  </go-card>

  <go-card id="form-select-theme" class="go-column go-column--100">
    <ng-container go-card-header>
      <h2 class="go-heading-2 go-heading--no-wrap">Component Theme</h2>
      <go-copy cardId="form-select-theme" goCopyCardLink></go-copy>
    </ng-container>
    <div class="go-container" go-card-content>

      <div class="go-column go-column--100">
        <p class="go-body-copy go-body-copy--no-margin">
          By default the theme for the select component is 'light', but there could be
          an instance where we need a 'dark' theme. There is a binding
          available for that.
        </p>
      </div>

      <div class="go-column go-column--100 go-column--no-padding">
        <div class="go-container">
          <div class="go-column go-column--50 go-column--dark">
            <h4 class="go-heading-4 go-heading--underlined" style="color: #fff;">View</h4>
            <go-select
              [control]="select20"
              label="Favorite Candy"
              theme="dark">
            </go-select>
          </div>
          <div class="go-column go-column--50">
            <h4 class="go-heading-4 go-heading--underlined">Code</h4>
            <code
              [highlight]="select20Code"
              class="code-block--no-bottom-margin">
            </code>
          </div>
        </div>
      </div>

    </div>
  </go-card>

  <go-card id="form-select-errors" class="go-column go-column--100">
    <ng-container go-card-header>
      <h2 class="go-heading-2 go-heading--no-wrap">Component Errors</h2>
      <go-copy cardId="form-select-errors" goCopyCardLink></go-copy>
    </ng-container>
    <div class="go-container" go-card-content>

      <div class="go-column go-column--100">
        <p class="go-body-copy">
          FormControls all have a <a class="go-link" href="https://angular.io/api/forms/AbstractControl#setErrors">consistent way of setting errors</a>
          via the <code class="code-block--inline">setErrors()</code> function.
          All goponents use this API to display errors on our components, but the
          data needs to be displayed in a specific structure.
        </p>
        <p class="go-body-copy go-body-copy--no-margin">
          By default the error type is set to "Error", however this can be
          overridden as shown below.
        </p>
      </div>

      <div class="go-column go-column--100 go-column--no-padding">
        <div class="go-container">
          <div class="go-column go-column--50">
            <h4 class="go-heading-4 go-heading--underlined">View</h4>
            <go-select
              [control]="select5"
              label="Favorite Candy">
            </go-select>
          </div>
          <div class="go-column go-column--50">
            <h4 class="go-heading-4 go-heading--underlined">Code</h4>
            <code
              [highlight]="select5Code"
              class="code-block--no-bottom-margin">
            </code>
            <code
              [highlight]="select5ErrorsCode"
              class="code-block--no-bottom-margin">
            </code>
          </div>
        </div>
      </div>

    </div>
  </go-card>

  <go-card id="form-select-disabled" class="go-column go-column--100">
    <ng-container go-card-header>
      <h2 class="go-heading-2 go-heading--no-wrap">Disable Component</h2>
      <go-copy cardId="form-select-disabled" goCopyCardLink></go-copy>
    </ng-container>
    <div class="go-container" go-card-content>

      <div class="go-column go-column--100">
        <p class="go-body-copy go-body-copy--no-margin">
          FormControls can be either created as disabled or later disabled
          and re-enabled directly after they are created.
        </p>
      </div>

      <div class="go-column go-column--100 go-column--no-padding">
        <div class="go-container">
          <div class="go-column go-column--50">
            <h4 class="go-heading-4 go-heading--underlined">View</h4>
            <div class="go-container">
              <div class="go-column go-column--100">
                <go-select
                  [control]="select19"
                  label="Favorite Candy">
                </go-select>
              </div>
            </div>
          </div>
          <div class="go-column go-column--50">
            <h4 class="go-heading-4 go-heading--underlined">Code</h4>
            <code
              [highlight]="basicDisabledExample"
              class="code-block--no-bottom-margin">
            </code>
            <code
              [highlight]="basicDisabledExample2"
              class="code-block--no-bottom-margin">
            </code>
            <code
              [highlight]="basicDisabledExample3"
              class="code-block--no-bottom-margin">
            </code>
          </div>
        </div>
      </div>

    </div>
  </go-card>

  <go-card id="form-select-items" class="go-column go-column--100">
    <ng-container go-card-header>
      <h2 class="go-heading-2 go-heading--no-wrap">Component Items</h2>
      <go-copy cardId="form-select-items" goCopyCardLink></go-copy>
    </ng-container>
    <div class="go-container" go-card-content>

      <div class="go-column go-column--100">
        <p class="go-body-copy go-body-copy--no-margin">
          Selects are pretty useless without options to choose from. The <code class="code-block--inline">@Input() items: any[];</code>
          binding allows an array of options to be passed in. This array can either be an array of strings or objects. If it's
          an array of objects you will also need to pass both a <code class="code-block--inline">@Input() bindLabel: string</code> and a
          <code class="code-block--inline">@Input() bindValue: string</code> attribute. The <code class="code-block--inline">bindLabel</code> attribute
          is used to tell the select what we should show for each option while the <code class="code-block--inline">bindValue</code> attribute
          is used to tell the select what value we want to save for each option. Both should reference a key on each object in the item array.
        </p>
      </div>

      <div class="go-column go-column--100 go-column--no-padding">
        <div class="go-container">
          <div class="go-column go-column--50">
            <h4 class="go-heading-4 go-heading--underlined">View</h4>
            <go-select
              bindLabel="name"
              bindValue="value"
              [control]="select6"
              [items]="items"
              label="Favorite Candy">
            </go-select>
          </div>
          <div class="go-column go-column--50">
            <h4 class="go-heading-4 go-heading--underlined">Code</h4>
            <code
              [highlight]="select6Code"
              class="code-block--no-bottom-margin">
            </code>
            <code
              [highlight]="select6ItemCode"
              class="code-block--no-bottom-margin">
            </code>
          </div>
        </div>
      </div>

    </div>
  </go-card>

  <go-card id="form-select-multiple" class="go-column go-column--100">
    <ng-container go-card-header>
      <h2 class="go-heading-2 go-heading--no-wrap">Component Multiple</h2>
      <go-copy cardId="form-select-multiple" goCopyCardLink></go-copy>
    </ng-container>
    <div class="go-container" go-card-content>

      <div class="go-column go-column--100">
        <p class="go-body-copy go-body-copy--no-margin">
          Sometimes we may want to be able to select multiple things. We can achieve this through the
          <code class="code-block--inline">@Input() multiple: boolean = false;</code> binding. Setting <code class="code-block--inline">multiple</code>
          to true will turn the select into a multi select and will save an array of values instead of a single value.
        </p>
      </div>

      <div class="go-column go-column--100">
        <div class="go-container">
          <div class="go-column go-column--50">
            <h4 class="go-heading-4 go-heading--underlined">View</h4>
            <go-select
              bindLabel="name"
              bindValue="value"
              [control]="select7"
              [items]="items"
              [multiple]="true"
              label="Favorite Candy">
            </go-select>
          </div>
          <div class="go-column go-column--50">
            <h4 class="go-heading-4 go-heading--underlined">Code</h4>
            <code
              [highlight]="select7Code"
              class="code-block--no-bottom-margin">
            </code>
          </div>
        </div>
      </div>

      <div class="go-column go-column--100 go-column--no-padding">
        <div class="go-container">
          <div class="go-column go-column--100">
            If need be, you can also remove the "Select All" button using the
            <code class="code-block--inline">@Input() showSelectAll: boolean = false;</code> binding.
          </div>
          <div class="go-column go-column--50">
            <h4 class="go-heading-4 go-heading--underlined">View</h4>
            <go-select
              bindLabel="name"
              bindValue="value"
              [control]="select17"
              [items]="items"
              [multiple]="true"
              [showSelectAll]="false"
              label="Favorite Candy">
            </go-select>
          </div>
          <div class="go-column go-column--50">
            <h4 class="go-heading-4 go-heading--underlined">Code</h4>
            <code
              [highlight]="select17Code_noSelectAll"
              class="code-block--no-bottom-margin">
            </code>
          </div>
        </div>
      </div>

    </div>
  </go-card>

  <go-card id="form-select-placeholder" class="go-column go-column--100">
    <ng-container go-card-header>
      <h2 class="go-heading-2 go-heading--no-wrap">Component Placeholder</h2>
      <go-copy cardId="form-select-placeholder" goCopyCardLink></go-copy>
    </ng-container>
    <div class="go-container" go-card-content>

      <div class="go-column go-column--100">
        <p class="go-body-copy go-body-copy--no-margin">
          Sometimes we may want to be able to add a placeholder for the select box. We can achieve this through the
          <code class="code-block--inline">@Input() placeholder: string;</code> binding. Setting
          <code class="code-block--inline">placeholder</code> to a string will display that string by default in the
          select box. When you select an option in the select box, it will replace the placeholder with the selected item.
        </p>
      </div>

      <div class="go-column go-column--100 go-column--no-padding">
        <div class="go-container">
          <div class="go-column go-column--50">
            <h4 class="go-heading-4 go-heading--underlined">View</h4>
            <go-select
              bindLabel="name"
              bindValue="value"
              [control]="select8"
              [items]="items"
              [multiple]="true"
              placeholder="Select a Candy"
              label="Favorite Candy">
            </go-select>
          </div>
          <div class="go-column go-column--50">
            <h4 class="go-heading-4 go-heading--underlined">Code</h4>
            <code
              [highlight]="select8Code"
              class="code-block--no-bottom-margin">
            </code>
          </div>
        </div>
      </div>

    </div>
  </go-card>

  <go-card id="form-select-loading" class="go-column go-column--100">
    <ng-container go-card-header>
      <h2 class="go-heading-2 go-heading--no-wrap">Component Loading</h2>
      <go-copy cardId="form-select-loading" goCopyCardLink></go-copy>
    </ng-container>
    <div class="go-container" go-card-content>

      <div class="go-column go-column--100">
        <p class="go-body-copy go-body-copy--no-margin">
          Sometimes we may want to indicate that the items for our select have not yet been retrieved. We can achieve this through the
          <code class="code-block--inline">@Input() loading: boolean = false;</code> binding. Setting <code class="code-block--inline">loading</code>
          to true will display a loading spinner within the select to indicate that the items are not yet available,
          while setting <code class="code-block--inline">loading</code> to false will remove the spinner and allow the select to function normally.
        </p>
      </div>

      <div class="go-column go-column--100 go-column--no-padding">
        <div class="go-container">
          <div class="go-column go-column--50">
            <h4 class="go-heading-4 go-heading--underlined">View</h4>
            <go-select
              bindLabel="name"
              bindValue="value"
              [control]="select9"
              [items]="items"
              [multiple]="true"
              label="Favorite Candy"
              [loading]="loadingSelectOptions">
            </go-select>
          </div>
          <div class="go-column go-column--50">
            <h4 class="go-heading-4 go-heading--underlined">Code</h4>
            <code
              [highlight]="select9Code"
              class="code-block--no-bottom-margin">
            </code>
            <code
              [highlight]="select9LoadingCode"
              class="code-block--no-bottom-margin">
            </code>
          </div>
        </div>
      </div>

    </div>
  </go-card>

  <go-card id="form-select-appendto" class="go-column go-column--100">
    <ng-container go-card-header>
      <h2 class="go-heading-2 go-heading--no-wrap">Component appendTo</h2>
      <go-copy cardId="form-select-appendto" goCopyCardLink></go-copy>
    </ng-container>
    <div class="go-container" go-card-content>

      <div class="go-column go-column--100">
        <p class="go-body-copy go-body-copy--no-margin">
          The <code class="code-block--inline">@Input() appendTo: string;</code> binding is useful when implementing a
          <code class="code-block--inline">go-select</code> within a <code class="code-block--inline">go-modal</code>.
          Setting <code class="code-block--inline">appendTo</code> to <code class="code-block--inline">'body'</code> will prevent
          the modal from closing automatically upon selecting an item from the select dropdown.
        </p>
      </div>

      <div class="go-column go-column--100 go-column--no-padding">
        <div class="go-container">
          <div class="go-column go-column--50">
            <h4 class="go-heading-4 go-heading--underlined">View</h4>
            <go-button (handleClick)="openModal()">Click Me</go-button>
          </div>
          <div class="go-column go-column--50">
            <h4 class="go-heading-4 go-heading--underlined">Code</h4>
            <code
              [highlight]="select10OpenModalCode"
              class="code-block--no-bottom-margin">
            </code>
          </div>
        </div>
      </div>

    </div>
  </go-card>

  <go-card id="form-select-typeahead" class="go-column go-column--100">
    <ng-container go-card-header>
      <h2 class="go-heading-2 go-heading--no-wrap">Component Typeahead</h2>
      <go-copy cardId="form-select-typeahead" goCopyCardLink></go-copy>
    </ng-container>
    <div class="go-container" go-card-content>

      <div class="go-column go-column--100">
        <p class="go-body-copy go-body-copy--no-margin">
          Sometimes we may want to use typeahead functionality in order to get the results from the server based
          on a users input. The <code class="code-block--inline">@Input() typeahead?: Subject&lt;string&gt;;</code> binding.
          can be used to pass a typeahead string through to do server side searching using an observable with rxjs.
        </p>
      </div>

      <div class="go-column go-column--100 go-column--no-padding">
        <div class="go-container">
          <div class="go-column go-column--50">
            <h4 class="go-heading-4 go-heading--underlined">View</h4>
            <go-select
              bindLabel="name"
              bindValue="value"
              label="Candy"
              placeholder="Search for a candy"
              [control]="select11"
              [items]="options$ | async"
              [loading]="loadingTypeahead"
              [typeahead]="itemInput">
            </go-select>
          </div>
          <div class="go-column go-column--50">
            <h4 class="go-heading-4 go-heading--underlined">Code</h4>
            <code
              [highlight]="select11Code"
              class="code-block--no-bottom-margin">
            </code>
            <code
              [highlight]="select11ComponentCode"
              class="code-block--no-bottom-margin">
            </code>
          </div>
        </div>
      </div>

    </div>
  </go-card>

  <go-card id="form-select-search" class="go-column go-column--100">
    <ng-container go-card-header>
      <h2 class="go-heading-2 go-heading--no-wrap">Component Search</h2>
      <go-copy cardId="form-select-search" goCopyCardLink></go-copy>
    </ng-container>
    <div class="go-container" go-card-content>

      <div class="go-column go-column--100">
        <p class="go-body-copy go-body-copy--no-margin">
          By default, the component has search functionality, allowing for local typeahead on items already loaded into
          the dropdown. The <code class="code-block--inline">@Input() searchable?: boolean;</code> binding
          can be used to disable this feature, allowing the component to act as a regular dropdown.
        </p>
      </div>
      <div class="go-column go-column--100 go-column--no-padding">
        <div class="go-container">
          <div class="go-column go-column--50">
            <h4 class="go-heading-4 go-heading--underlined">View</h4>
            <go-select
              bindLabel="name"
              bindValue="value"
              [control]="select15"
              [items]="items"
              [searchable]="false"
              label="Your Input">
            </go-select>
          </div>
          <div class="go-column go-column--50">
            <h4 class="go-heading-4 go-heading--underlined">Code</h4>
            <code
              [highlight]="select15Code"
              class="code-block--no-bottom-margin">
            </code>
          </div>
        </div>
      </div>
    </div>
  </go-card>

  <go-card id="form-select-groupby" class="go-column go-column--100">
    <ng-container go-card-header>
      <h2 class="go-heading-2 go-heading--no-wrap">Component groupBy</h2>
      <go-copy cardId="form-select-groupby" goCopyCardLink></go-copy>
    </ng-container>
    <div class="go-container" go-card-content>

      <div class="go-column go-column--100">
        <p class="go-body-copy go-body-copy--no-margin">
          The <code class="code-block--inline">@Input() groupBy: string;</code> binding is useful when implementing a
          <code class="code-block--inline">go-select</code> that has categories for the items being rendered in the dropdown.
          The value should be a string of the key to group by on each item.
        </p>
      </div>

      <div class="go-column go-column--100 go-column--no-padding">
        <div class="go-container">
          <div class="go-column go-column--50">
            <h4 class="go-heading-4 go-heading--underlined">View</h4>
            <go-select
              bindLabel="name"
              bindValue="value"
              [control]="select12"
              groupBy="manufacturer"
              [items]="groupedItems"
              label="Favorite Car">
            </go-select>
          </div>
          <div class="go-column go-column--50">
            <h4 class="go-heading-4 go-heading--underlined">Code</h4>
            <code
              [highlight]="select12Code"
              class="code-block--no-bottom-margin">
            </code>
            <code
              [highlight]="select12ComponentCode"
              class="code-block--no-bottom-margin">
            </code>
          </div>
        </div>
      </div>

    </div>
  </go-card>

  <go-card id="form-select-clearable" class="go-column go-column--100">
    <ng-container go-card-header>
      <h2 class="go-heading-2 go-heading--no-wrap">Component clearable</h2>
      <go-copy cardId="form-select-clearable" goCopyCardLink></go-copy>
    </ng-container>
    <div class="go-container" go-card-content>

      <div class="go-column go-column--100">
        <p class="go-body-copy go-body-copy--no-margin">
          The <code class="code-block--inline">@Input() clearable: boolean = true;</code> binding is useful when implementing a
          <code class="code-block--inline">go-select</code> that should always have a value from the drop down assigned.
          This binding removes the "x" button on the right end of the input so that the value cannot be cleared.
        </p>
      </div>

      <div class="go-column go-column--100 go-column--no-padding">
        <div class="go-container">
          <div class="go-column go-column--50">
            <h4 class="go-heading-4 go-heading--underlined">View</h4>
            <go-select
              bindLabel="name"
              bindValue="value"
              [clearable]="false"
              [control]="select16"
              [items]="items"
              label="Select an option">
            </go-select>
          </div>
          <div class="go-column go-column--50">
            <h4 class="go-heading-4 go-heading--underlined">Code</h4>
            <code
              [highlight]="select16Code"
              class="code-block--no-bottom-margin">
            </code>
            <code
              [highlight]="select16ComponentCode"
              class="code-block--no-bottom-margin">
            </code>
          </div>
        </div>
      </div>

    </div>
  </go-card>

  <go-card id="form-select-hideDropDownArrow" class="go-column go-column--100">
    <ng-container go-card-header>
      <h2 class="go-heading-2 go-heading--no-wrap">Component hideDropDownArrow</h2>
      <go-copy cardId="form-select-hideDropDownArrow" goCopyCardLink></go-copy>
    </ng-container>
    <div class="go-container" go-card-content>

      <div class="go-column go-column--100">
        <p class="go-body-copy go-body-copy--no-margin">
          The <code class="code-block--inline">@Input() hideDropDownArrow: boolean = false;</code> binding can be used
          to forcefully hide the drown down arrow in the select.
        </p>
      </div>

      <div class="go-column go-column--100 go-column--no-padding">
        <div class="go-container">
          <div class="go-column go-column--50">
            <h4 class="go-heading-4 go-heading--underlined">View</h4>
            <go-select
              bindLabel="name"
              bindValue="value"
              [hideDropDownArrow]="true"
              [control]="select22"
              [items]="items"
              label="Select an option">
            </go-select>
          </div>
          <div class="go-column go-column--50">
            <h4 class="go-heading-4 go-heading--underlined">Code</h4>
            <code
              [highlight]="select22Code"
              class="code-block--no-bottom-margin">
            </code>
          </div>
        </div>
      </div>

    </div>
  </go-card>

  <go-card id="form-select-template" class="go-column go-column--100">
    <ng-container go-card-header>
      <h2 class="go-heading-2 go-heading--no-wrap">Component Template</h2>
      <go-copy cardId="form-select-template" goCopyCardLink></go-copy>
    </ng-container>
    <div class="go-container" go-card-content>

      <div class="go-column go-column--100">
        <p class="go-body-copy go-body-copy--no-margin">
          It's possible to add a custom template with the select options by adding a <code class="code-block--inline">
          ng-template</code> with a <code class="code-block--inline">#goSelectOption</code>
        </p>
      </div>

      <div class="go-column go-column--100 go-column--no-padding">
        <div class="go-container">
          <div class="go-column go-column--50">
            <h4 class="go-heading-4 go-heading--underlined">View</h4>
            <go-select
              bindValue="value"
              [control]="select13"
              [items]="items"
              label="Select an Option">
              <ng-template #goSelectOption let-candy>
                {{ candy.value }} - {{ candy.name }}
              </ng-template>
            </go-select>
          </div>
          <div class="go-column go-column--50">
            <h4 class="go-heading-4 go-heading--underlined">Code</h4>
            <code
              [highlight]="select13Code"
              class="code-block--no-bottom-margin">
            </code>
            <code
              [highlight]="select13ComponentCode"
              class="code-block--no-bottom-margin">
            </code>
          </div>
        </div>
      </div>

    </div>
  </go-card>

  <go-card id="form-select-template-optgroup" class="go-column go-column--100">
    <ng-container go-card-header>
      <h2 class="go-heading-2 go-heading--no-wrap">Component Optgroup Label Template</h2>
      <go-copy cardId="form-select-template-optgroup" goCopyCardLink></go-copy>
    </ng-container>
    <div class="go-container" go-card-content>

      <div class="go-column go-column--100">
        <p class="go-body-copy go-body-copy--no-margin">
          When grouping, you may need to customize the optgroup label, for example when using the
          <a
            href="https://github.com/ng-select/ng-select/tree/0eec42cb8df68b1ca57d305f25a36a8e8618ce6e/src/demo/app/examples/group-children-example"
            target="_blank">grouped children array</a> from ng-select where the label cannot be inferred.
          You can add a custom template by adding a <code class="code-block--inline">ng-template</code> with a <code class="code-block--inline">#goSelectOptionGroup</code>
        </p>
      </div>

      <div class="go-column go-column--100 go-column--no-padding">
        <div class="go-container">
          <div class="go-column go-column--50">
            <h4 class="go-heading-4 go-heading--underlined">View</h4>
            <go-select
              bindValue="value"
              bindLabel="name"
              [control]="select18"
              [items]="groupedItemsArray"
              groupBy="cars"
              label="Select an Option">
              <ng-template #goSelectOptionGroup let-item>
                {{ item.manufacturer | uppercase }}
              </ng-template>
            </go-select>
          </div>
          <div class="go-column go-column--50">
            <h4 class="go-heading-4 go-heading--underlined">Code</h4>
            <code
              [highlight]="select18Code"
              class="code-block--no-bottom-margin">
            </code>
            <code
              [highlight]="select18ComponentCode"
              class="code-block--no-bottom-margin">
            </code>
          </div>
        </div>
      </div>

    </div>
  </go-card>

  <go-card id="form-select-template" class="go-column go-column--100">
    <ng-container go-card-header>
      <h2 class="go-heading-2 go-heading--no-wrap">Component Label Template</h2>
      <go-copy cardId="form-select-template" goCopyCardLink></go-copy>
    </ng-container>
    <div class="go-container" go-card-content>

      <div class="go-column go-column--100">
        <p class="go-body-copy go-body-copy--no-margin">
          There might be times where a template that is being used for options is long and we don't
          need as much information after the option is selected. This can be achieved by adding a second
          <code class="code-block--inline">ng-template</code> with a <code class="code-block--inline">#goSelectSelectedOption</code>
        </p>
      </div>

      <div class="go-column go-column--100 go-column--no-padding">
        <div class="go-container">
          <div class="go-column go-column--50">
            <h4 class="go-heading-4 go-heading--underlined">View</h4>
            <go-select
              bindValue="value"
              [control]="select14"
              [items]="items"
              label="Select an Option">
              <ng-template #goSelectSelectedOption let-candy>
                {{ candy.name }}
              </ng-template>
              <ng-template #goSelectOption let-candy>
                <div>
                  Value: {{ candy.value }}
                </div>
                <div>
                  Name: {{ candy.name }}
                </div>
              </ng-template>
            </go-select>
          </div>
          <div class="go-column go-column--50">
            <h4 class="go-heading-4 go-heading--underlined">Code</h4>
            <code
              [highlight]="select14Code"
              class="code-block--no-bottom-margin">
            </code>
            <code
              [highlight]="select14ComponentCode"
              class="code-block--no-bottom-margin">
            </code>
          </div>
        </div>
      </div>

    </div>
  </go-card>

  <go-card id="form-select-template" class="go-column go-column--100">
    <ng-container go-card-header>
      <h2 class="go-heading-2 go-heading--no-wrap">Component Virtual scroll</h2>
      <go-copy cardId="form-select-virtual-scroll" goCopyCardLink></go-copy>
    </ng-container>
    <div class="go-container" go-card-content>
      <div class="go-column go-column--100">
        <p class="go-body-copy">
          Sometimes the data that needs to be rendered for the options of the select would cause performance and user 
          experience issues. In this case, virtual scroll should be implemented.
        </p>
        
        <p class="go-body-copy">
          To do so, implement the <code class="code-block--inline">scrollToEnd</code> method on the select. When 
          the user scrolls to the end of the current available options, the event will fire which will allow the implementor to 
          fetch more options and add them to the array of items. This event will only fire after setting <code class="code-block--inline">virtualScroll</code> to true on the select component.
        </p>
        
        <p class="go-body-copy go-body-copy--no-margin">
          For more information on this, check the
          <a
            href="https://ng-select.github.io/ng-select#/virtual-scroll"
            class="go-link">
              ng-select documentation
          </a>
          for implementing virtual scroll.
        </p>
      </div>
      <div class="go-column go-column--100 go-column--no-padding">
        <div class="go-container">
          <div class="go-column go-column--50">
            <h4 class="go-heading-4 go-heading--underlined">View</h4>
            <go-select 
              [items]="selectData" 
              [control]="select21" 
              bindValue="value" 
              bindLabel="name" 
              [hints]="[
              'Scroll to end for loading more data.'
              ]" 
              label="Select an Option" 
              (scrollToEnd)="scrollToEnd()" 
              (scroll)="scroll($event)"
              [virtualScroll]="true">
            </go-select>
          </div>
          <div class="go-column go-column--50">
            <h4 class="go-heading-4 go-heading--underlined">Code</h4>
            <code [highlight]="select21Code" class="code-block--no-bottom-margin">
            </code>
            <code [highlight]="select21ComponentCode" class="code-block--no-bottom-margin">
            </code>
          </div>
        </div>
      </div>
    </div>

  </go-card>
</section>
